import React, { useState } from "react";
import {
  AppBar, Toolbar, Typography, Box, Avatar, Menu, MenuItem,
  IconButton, Divider, Stack, Tooltip,
} from "@mui/material";
import { Logout, Person } from "@mui/icons-material";
import { alpha, useTheme } from "@mui/material/styles";

export default function PortalNavbar({ clientData, onLogout }) {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);

  const companyName = clientData?.company_name || "Cliente";
  const email = clientData?.email || "";
  const initials = companyName.split(" ").map((w) => w[0]).join("").toUpperCase().slice(0, 2);

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        background: `linear-gradient(90deg, ${theme.palette.primary.dark}, ${theme.palette.primary.main})`,
        borderBottom: `1px solid ${alpha("#fff", 0.1)}`,
      }}
    >
      <Toolbar sx={{ gap: 1 }}>
        {/* Logo / Brand */}
        <Stack direction="row" alignItems="center" spacing={1.5} sx={{ flexGrow: 1 }}>
          <Box
            sx={{
              width: 36, height: 36, borderRadius: 2,
              bgcolor: alpha("#fff", 0.15),
              display: "flex", alignItems: "center", justifyContent: "center",
              fontWeight: "bold", fontSize: 13, color: "#fff",
            }}
          >
            EC
          </Box>
          <Box sx={{ display: { xs: "none", sm: "block" } }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
              Portale Clienti
            </Typography>
            <Typography variant="caption" sx={{ opacity: 0.75, fontSize: 10, letterSpacing: 0.5 }}>
              Ecotrade
            </Typography>
          </Box>
        </Stack>

        {/* Avatar account */}
        <Tooltip title={companyName}>
          <Avatar
            onClick={(e) => setAnchorEl(e.currentTarget)}
            sx={{
              cursor: "pointer", width: 36, height: 36, fontSize: 13, fontWeight: 600,
              bgcolor: alpha("#fff", 0.2),
              "&:hover": { transform: "scale(1.05)" },
              transition: "all 0.2s",
            }}
          >
            {initials}
          </Avatar>
        </Tooltip>

        {/* Menu account */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
          PaperProps={{ sx: { mt: 1.5, minWidth: 220, borderRadius: 3 } }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <Box sx={{ px: 2, py: 1.5, bgcolor: alpha(theme.palette.primary.main, 0.05) }}>
            <Stack direction="row" spacing={1.5} alignItems="center">
              <Avatar sx={{ bgcolor: theme.palette.primary.main, width: 36, height: 36, fontSize: 13 }}>
                {initials}
              </Avatar>
              <Box>
                <Typography variant="subtitle2" fontWeight={600}>{companyName}</Typography>
                <Typography variant="caption" color="text.secondary">{email}</Typography>
              </Box>
            </Stack>
          </Box>
          <Divider />
          <MenuItem onClick={() => { setAnchorEl(null); onLogout(); }} sx={{ py: 1.5, color: "error.main" }}>
            <Logout fontSize="small" sx={{ mr: 1.5 }} />
            Esci
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
}
